import BaseSetup from '@/components/BaseSetup';
import useBotpressService from '@/services/BotpressService';

export type SharedBotpressEmits = {};
export type SharedBotpressProps = {};

export default class SharedBotpressSetup extends BaseSetup {

	static readonly defaultProps = {};

	private readonly botpressService = useBotpressService();

	constructor (
		private props: SharedBotpressProps,
		private emits: SharedBotpressEmits,
	) {
		super();
	}

	protected onMounted () {
		// Le composant n'est monté que pour les Travailleurs (v-if dans SharedLayout),
		// on charge donc le chatbot uniquement pour eux. Chargement non bloquant.
		this.botpressService.loadAsync().catch(() => {});
	}

}
